import { useState } from 'react'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline';

// component
import DrawerBase from './drawer.base';

export const DrawerPartnerUploadedDocument = (props) => {
  // input
  const { 
    open = false , 
    setOpen = () => {},
    url = null,
  } = props;
  // const [open, setOpen] = useState(true)

  return (
    <DrawerBase
      open={open}
      setOpen={setOpen}
      title='Uploaded Documents'
      description='Strategic Partner uploaded document'
    >
      <iframe className='h-full w-full' width={1000} height={500} src={url}></iframe>
    </DrawerBase>
  )
}
